import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const BadgeManagementRoutes: Routes = [
  {
    path: "badge-management",
    loadComponent: () =>
      import("./badge-management/badge-management.component").then(
        (m) => m.BadgeManagementComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./badge-management-list/badge-management-list.component").then(
            (m) => m.BadgeManagementListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./badge-management-form/badge-management-form.component").then(
            (m) => m.BadgeManagementFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./badge-management-form/badge-management-form.component").then(
            (m) => m.BadgeManagementFormComponent,
          ),
      },
      {
        path: "view/:id/items",
        loadComponent: () =>
          import("./badge-item-form/badge-item-form.component").then(
            (m) => m.BadgeItemFormComponent,
          ),
      },
      {
        path: "view/:id/items/:itemId",
        loadComponent: () =>
          import("./badge-item-form/badge-item-form.component").then(
            (m) => m.BadgeItemFormComponent,
          ),
      },
      {
        path: "icons",
        loadComponent: () =>
          import("./badge-icons-list/badge-icons-list.component").then(
            (m) => m.BadgeIconsListComponent,
          ),
      },
    ],
  },
];
